import { render } from "./brand_balance.vue?vue&type=template&id=4448a4b6"
import script from "./brand_balance.vue?vue&type=script&lang=js"
export * from "./brand_balance.vue?vue&type=script&lang=js"

import "./brand_balance.vue?vue&type=style&index=0&id=4448a4b6&lang=css"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__